var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.show_if)?_vm._t("default"):_c('lottie',{staticStyle:{"height":"8rem"},attrs:{"options":{animationData: _vm.componentAnimationData}}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }